import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { roleAccess } from "../config";

function PrivateRoute({ children }) {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const allowedRoutes = roleAccess[user.role] || [];
  const currentPath = location.pathname;

  if (!allowedRoutes.includes(currentPath)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default PrivateRoute;
